import React, { useState, useContext } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import { FaLock, FaEnvelope, FaSignInAlt } from "react-icons/fa";

export default function LoginPainelCircuito() {
  const { loginUser } = useContext(UserContext);
  const navigate = useNavigate();
  const contextData = useOutletContext(); 

  // 💡 CORREÇÃO: Todos os Hooks DEVEM ficar no topo, antes de qualquer "return"
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [loading, setLoading] = useState(false);

  // Prevenção de segurança caso o context ainda não tenha carregado
  if (!contextData || !contextData.circuito) return null;

  const { circuito, slugAtivo } = contextData;

  // Lógica independente para saber se estamos no domínio próprio
  const isCustomDomain = window.location.hostname !== "ticketdovaqueiro.com" && 
                         window.location.hostname !== "www.ticketdovaqueiro.com" && 
                         window.location.hostname !== "localhost";
                         
  const basePath = isCustomDomain ? "/painel" : `/painel-circuito/${slugAtivo}`;

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro("");
    setLoading(true);

    try {
      const res = await axios.post("https://api.ticketdovaqueiro.com/api/auth/login", { email, senha });
      const { user, token } = res.data;

      // TRAVA DE SEGURANÇA MÁXIMA
      if (user.tipo !== "admin" && (user.tipo !== "gerente_circuito" || user.circuitoId !== circuito._id)) {
        setErro("Seu usuário não tem permissão para acessar o painel deste circuito.");
        setLoading(false);
        return;
      }

      loginUser(user, token);
      navigate(`${basePath}`); 

    } catch (err) {
      setErro(err.response?.data?.mensagem || "Email ou senha incorretos.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--c-bg, #0f0f0f)", padding: "20px" }}>
      <div style={{ maxWidth: "400px", width: "100%", background: "var(--c-card, #171717)", padding: "40px", borderRadius: "16px", boxShadow: "0 10px 40px rgba(0,0,0,0.5)", border: "1px solid rgba(255,255,255,0.05)", textAlign: "center" }}>
        
        {circuito?.imagem ? (
            <img src={`https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}`} alt="Logo" style={{ width: "120px", height: "120px", objectFit: "cover", borderRadius: "50%", marginBottom: "20px", border: "2px solid var(--c-accent, #d4af37)" }} />
        ) : (
            <div style={{ width: "80px", height: "80px", borderRadius: "50%", background: "var(--c-accent, #d4af37)", margin: "0 auto 20px" }}></div>
        )}

        <h2 style={{ color: "#fff", marginBottom: "8px", fontSize: "22px" }}>Acesso Administrativo</h2>
        <p style={{ color: "rgba(255,255,255,0.6)", marginBottom: "32px", fontSize: "14px" }}>Gerencie o circuito {circuito.nome}</p>

        {erro && <div style={{ background: "rgba(239, 68, 68, 0.1)", color: "#ef4444", padding: "12px", borderRadius: "8px", marginBottom: "20px", fontSize: "14px", border: "1px solid rgba(239, 68, 68, 0.3)" }}>{erro}</div>}

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "16px", textAlign: "left" }}>
          <div style={{ position: "relative" }}>
            <FaEnvelope style={{ position: "absolute", top: "14px", left: "16px", color: "rgba(255,255,255,0.4)" }} />
            <input 
              type="email" 
              required 
              placeholder="E-mail de Acesso" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              style={{ width: "100%", height: "44px", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", paddingLeft: "44px", color: "#fff", outline: "none", boxSizing: "border-box" }} 
            />
          </div>
          <div style={{ position: "relative" }}>
            <FaLock style={{ position: "absolute", top: "14px", left: "16px", color: "rgba(255,255,255,0.4)" }} />
            <input 
              type="password" 
              required 
              placeholder="Senha" 
              value={senha} 
              onChange={e => setSenha(e.target.value)} 
              style={{ width: "100%", height: "44px", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", paddingLeft: "44px", color: "#fff", outline: "none", boxSizing: "border-box" }} 
            />
          </div>
          
          <button type="submit" disabled={loading} style={{ background: "var(--c-accent, #d4af37)", color: "var(--texto-botao, #000)", border: "none", height: "48px", borderRadius: "8px", fontWeight: "bold", fontSize: "16px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginTop: "10px" }}>
            {loading ? "Entrando..." : <><FaSignInAlt /> Acessar Painel</>}
          </button>
        </form>
      </div>
    </div>
  );
}